import { get, post } from '../utils/networking';

/** A company found in Enhetsregisteret. «taken» when it already has a Trustpulse account. */
export type CompanyHit = {
  orgNumber: string;
  name: string;
  postalPlace: string | null;
  employees: number | null;
  taken: boolean;
};

export type ChosenCompany =
  | { source: 'brreg'; orgNumber: string; name: string; postalPlace: string | null; employees: number | null }
  | { source: 'manual'; name: string };

export type LegalDocumentKind = 'TERMS' | 'DPA';

export type LegalLanguage = 'nb' | 'en';

/**
 * A text, or a PDF (contentType «application/pdf», empty content) read at «url». The sha256 is of the
 * text or of the PDF's bytes, and is what the acceptance records.
 */
export type LegalDocument = {
  kind: LegalDocumentKind;
  version: string;
  /** The language it is in, which can be Norwegian when there is no version in the one asked for */
  language: LegalLanguage;
  content: string;
  contentType: string;
  sha256: string;
  publishedAt: string;
  url: string | null;
};

export type StartSignup = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  company: { source: 'brreg'; orgNumber: string; name: string; employees: number | null } | { source: 'manual'; name: string };
  acceptedTerms: boolean;
  acceptedVersions: Partial<Record<LegalDocumentKind, string>>;
  language: 'nb' | 'en';
};

export const searchCompanies = (query: string) => get<CompanyHit[]>('/api/signup/companies', { params: { q: query } });
export const startSignup = (body: StartSignup) => post<{ email: string; codeMinutes: number }>('/api/signup/start', body);
export const resendSignupCode = (email: string) => post<{ email: string; codeMinutes: number }>('/api/signup/resend', { email });
/** The password goes again with the code, as Trustpulse does not keep it while the code is on its way */
export const verifySignup = (body: { email: string; code: string; password: string }) =>
  post<{ userAssignedRoles: string[] }>('/api/signup/verify', body);
export const getLegalDocuments = (language: LegalLanguage) =>
  get<LegalDocument[]>('/api/legal-documents/current', { params: { language } });
